import { render } from "./CreateFoodOrders.vue?vue&type=template&id=aa009d08"
import script from "./CreateFoodOrders.vue?vue&type=script&lang=js"
export * from "./CreateFoodOrders.vue?vue&type=script&lang=js"

import "./CreateFoodOrders.vue?vue&type=style&index=0&id=aa009d08&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__